export enum ImageType {
    JPEG = "image/jpeg",
    PNG = "image/png",
    ICO = "image/ico",
    TIF = "image/tif"
}
